import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/Button'

export function NotFoundPage() {
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50">
      <div className="text-center">
        <p className="text-sm font-medium text-brand-600">404</p>
        <h1 className="mt-2 text-2xl font-semibold text-slate-900">Az oldal nem található</h1>
        <p className="mt-1 text-sm text-slate-500">Lehet, hogy átmozgattuk vagy archiváltuk.</p>
        <div className="mt-6">
          <Link to="/invoices">
            <Button>Vissza a számlákhoz</Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
